export const CURRENT_TERMS_VERSION = '2025-11-03'
